import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
 import api from '../../utils/axios';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

export default function Login() {
  const { dispatch, loading } = useAuth(); // get loading state
  const navigate = useNavigate();

  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const res = await api.post(`${process.env.REACT_APP_API_URL}/api/auth/login`, form);
      const { user, token } = res.data;

      dispatch({ type: 'LOGIN', payload: { user, token } });

      navigate('/bookings'); // redirect after login
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    }
  };

  // ⏳ Show loader until auth context is initialized
  if (loading) return <p className="text-center mt-5">Loading...</p>;

  return (
    <div className="container mt-5" style={{ maxWidth: '400px' }}>
      <h2 className="mb-4">Login</h2>
      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Email</label>
          <input
            type="email"
            name="email"
            className="form-control"
            value={form.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label>Password</label>
          <input
            type="password"
            name="password"
            className="form-control"
            value={form.password}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit" className="btn btn-primary w-100">Login</button>
      </form>
      <p>
        <Link to="/forgot-password" className="text-primary">Forgot Password?</Link>
      </p>
    </div>
  );
}
